import { inject, Injectable } from '@angular/core';
import {
  Product,
  ProductExportListConfigService,
} from 'gung-standard';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { CultProductExportCardComponent } from '../components/cult-product-export-card/cult-product-export-card.component';
import { CultProductListConfigService } from './cult-product-list-config.service';
import { CultArQEliassonArtnrFilter } from './cult-product-list-v2-config.service';
import { CultProductExportTableComponent } from '../components/cult-product-export-table/cult-product-export-table.component';

@Injectable({
  providedIn: 'root'
})
export class CultProductExportListConfigService extends ProductExportListConfigService {
  protected productListConfigService = inject(CultProductListConfigService);

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => 'fas fa-th',
        getListItemComponent: () => CultProductExportCardComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      },
      {
        getIconClass: () => 'fas fa-list',
        getListItemComponent: () => CultProductExportTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductList'
      }
    ];
  }

  getBatchSizes() {
    return this.productListConfigService.getBatchSizes();
  }

  hideZeroOptions() {
    return this.productListConfigService.hideZeroOptions();
  }

  getFilters() {
    return [...super.getFilters(), , new CultArQEliassonArtnrFilter()];
  }
}
